@if (!$criandoCliente()) {
<div class="n-agenda-clientes-container">
  <!-- Campo de Busca e Botão de Novo Cliente -->
  <div class="n-top-section flex flex-column gap-3 mb-3">
    <div class="n-search-box">
      <p-iconfield class="w-full">
        <p-inputicon styleClass="pi pi-search text-primary font-bold" />
        <input
          pInputText
          type="text"
          [ngModel]="pesquisa()"
          (ngModelChange)="onPesquisaInput($event)"
          (keyup.enter)="buscarComFiltro()"
          [placeholder]="$nicho().cliente.placeholderBusca"
          class="w-full n-input-search"
        />
        @if (pesquisa()) {
          <p-inputicon styleClass="pi pi-times cursor-pointer text-500" (click)="limparPesquisa()" />
        }
      </p-iconfield>
    </div>

    <!-- Botão de Cadastrar Novo Cliente com visual suave e chevron -->
    <div
      class="n-btn-novo-cliente cursor-pointer flex align-items-center justify-content-between p-3"
      (click)="iniciarCriacao()"
      role="button"
      tabindex="0"
    >
      <div class="flex align-items-center gap-2 text-primary font-medium text-sm sm:text-base">
        <i class="pi pi-plus text-primary text-sm font-bold"></i>
        <span>{{ 'BARDO_CLIENTES.CADASTRAR_NOVO' | translate: { termo: ($nicho().cliente.singular | lowercase) } }}</span>
      </div>
      <i class="pi pi-chevron-right text-primary text-xs"></i>
    </div>
  </div>

  <!-- Contador de Clientes -->
  <div class="n-counter-header mb-2 flex align-items-center justify-content-between">
    <span class="text-xs font-bold text-500 uppercase tracking-wider">
      {{ $total() }} {{ $total() === 1 ? ($nicho().cliente.singular | uppercase) : ($nicho().cliente.plural | uppercase) }}
    </span>
  </div>


  @if ($exibirSkeleton()) {
  <div class="n-clientes-skeleton" aria-busy="true">
    @for (card of skeletonCards; track card) {
    <div class="n-skeleton-card">
      <p-skeleton shape="circle" size="2.625rem" />
      <div class="n-skeleton-card-texto">
        <p-skeleton width="62%" height="0.9rem" />
        <p-skeleton width="38%" height="0.7rem" />
      </div>
    </div>
    }
  </div>
  } @else {
  <!-- Grid de Cards Responsivo (Mobile & Desktop) -->
  <div class="n-clientes-grid">
    @for (cliente of $clientes(); track cliente.id) {
      <div
        class="n-cliente-card flex w-full align-items-center justify-content-between gap-3 p-3 cursor-pointer"
        [class.is-selected]="$clienteSelecionado()?.id === cliente.id"
        (click)="selectCliente(cliente, $event)"
        role="button"
        tabindex="0"
      >
        <!-- Conteúdo Principal (Avatar + Nome + Data/Badges inline) -->
        <div class="flex flex-1 align-items-center gap-3 min-w-0">
          <!-- Avatar -->
          <div
            class="n-avatar flex align-items-center justify-content-center text-white font-bold border-circle flex-shrink-0"
            [style.background-color]="getAvatarColor(cliente.id)"
          >
            {{ getIniciais(cliente.nome) }}
          </div>

          <!-- Nome e Informações Metadados -->
          <div class="min-w-0 flex-1 flex flex-column gap-1">
            <h3 class="n-cliente-nome m-0 text-color text-overflow-ellipsis overflow-hidden white-space-nowrap">
              {{ cliente.nome }}
            </h3>

            @if (cliente.dataNascimento) {
              <!-- Linha 2 (Com Aniversário): Data de Nascimento em linha própria -->
              <div class="n-birthdate-row flex align-items-center gap-1 text-xs text-500 mt-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="n-icon-cake text-400">
                  <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/>
                  <path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2 1 2 1"/>
                  <path d="M2 21h20"/>
                  <path d="M7 8v3"/>
                  <path d="M12 8v3"/>
                  <path d="M17 8v3"/>
                  <path d="M7 4h.01"/>
                  <path d="M12 4h.01"/>
                  <path d="M17 4h.01"/>
                </svg>
                <span>{{ cliente.dataNascimento | date:'dd/MM/yyyy':'UTC' }}</span>
              </div>
            }

            <!-- Linha de Pílulas (Dependente + Telefone na mesma linha) -->
            <div class="flex flex-wrap align-items-center gap-2 text-xs text-500 mt-1">
              @if (cliente.responsavelNome) {
                <span class="n-pill dependente">
                  <i class="pi pi-user text-xs"></i> {{ 'BARDO_CLIENTES.DEPENDENTE' | translate }}
                </span>
              } @else if (cliente.qtdDependentes && cliente.qtdDependentes > 0) {
                <span class="n-pill responsavel">
                  <i class="pi pi-users text-xs"></i> {{ cliente.qtdDependentes }} {{ cliente.qtdDependentes === 1 ? ('BARDO_CLIENTES.DEPENDENTE' | translate | lowercase) : ('BARDO_CLIENTES.DEPENDENTES' | translate | lowercase) }}
                </span>
              }

              <span class="n-pill phone">
                <i class="pi pi-phone text-xs"></i>
                {{ formatarTelefoneValor(cliente.telefone || cliente.responsavelTelefone) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Indicador de Ação (Alinhado no topo à direita) -->
        <div class="n-action-container flex align-items-center justify-content-center flex-shrink-0">
          @if ($clienteSelecionado()?.id === cliente.id) {
            <div class="n-action-circle selected flex align-items-center justify-content-center border-circle">
              <i class="pi pi-check text-white text-xs font-bold"></i>
            </div>
          } @else {
            <div class="n-action-circle flex align-items-center justify-content-center border-circle">
              <i class="pi pi-chevron-right text-400 text-xs"></i>
            </div>
          }
        </div>
      </div>
    } @empty {
      @if (!$loading()) {
        <div class="n-empty-state text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
          <i class="pi pi-users text-4xl block mb-2 text-400"></i>
          <p class="m-0 text-sm font-medium text-500">{{ 'BARDO_CLIENTES.NENHUM_ENCONTRADO' | translate: { termo: ($nicho().cliente.singular | lowercase) } }}</p>
        </div>
      }
    }
  </div>
  }

  <!-- Paginação -->
  @if ($total() > 0) {
    <div class="mt-3">
      <p-table
        [value]="$clientes()"
        [paginator]="true"
        [rows]="rows()"
        [first]="first()"
        [totalRecords]="$total()"
        [rowsPerPageOptions]="[6, 12, 24]"
        [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [loading]="$loading()"
        styleClass="p-datatable-borderless n-compact-paginator"
      >
        <ng-template #body let-cliente></ng-template>
      </p-table>
    </div>
  }
</div>
} @if ($criandoCliente()) {
<lib-cliente-create-edit
  [cliente]="null"
  (footerTemplateAction)="onFooterTemplate($event)"
  (saved)="onClienteSalvo()"
  (closed)="cancelarCriacao()"
/>
}

<!-- Modal / Bottom Sheet para Cliente Dependente (Mobile: Bottom Sheet | Desktop: Dialog) -->
@if (deviceService.$isMobile()) {
  <lib-bottom-sheet
    [visible]="$modalDependente().visivel"
    (visibleChange)="fecharModalDependente()"
    size="medium"
    [draggable]="true"
    [closeOnBackdrop]="true"
    [closeOnEscape]="true"
    (hide)="fecharModalDependente()"
  >
    <ng-container *ngTemplateOutlet="dependenteModalContent"></ng-container>
  </lib-bottom-sheet>
} @else {
  <p-dialog
    [(visible)]="$modalDependente().visivel"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '450px' }"
    styleClass="n-dialog-dependente border-round-2xl"
    (onHide)="fecharModalDependente()"
  >
    <ng-container *ngTemplateOutlet="dependenteModalContent"></ng-container>
  </p-dialog>
}

<!-- Template Conteúdo do Dependente (Reutilizável para Mobile e Desktop) -->
<ng-template #dependenteModalContent>
  <div class="flex flex-column gap-3 py-2">
    <div class="text-center">
      <span class="text-xs font-bold text-500 uppercase tracking-wider block mb-1">
        {{ 'BARDO_CLIENTES.CLIENTE_DEPENDENTE' | translate: { termo: ($nicho().cliente.singular | uppercase) } }}
      </span>

      <h3 class="m-0 text-xl font-bold text-color">
        {{ $modalDependente().cliente?.nome }}
      </h3>
    </div>

    <div class="n-responsavel-box p-3 border-round-xl surface-50 flex align-items-center gap-3">
      <div class="w-2rem h-2rem border-circle surface-200 flex align-items-center justify-content-center text-primary flex-shrink-0">
        <i class="pi pi-user text-sm font-bold"></i>
      </div>
      <div class="flex flex-column gap-1 min-w-0 flex-1">
        <span class="text-xs font-bold text-500 uppercase">{{ 'BARDO_CLIENTES.RESPONSAVEL' | translate }}</span>
        <span class="text-sm font-semibold text-color">
          {{ $modalDependente().cliente?.responsavelNome || ('BARDO_CLIENTES.NAO_INFORMADO' | translate) }}
        </span>
        @if ($modalDependente().cliente?.responsavelTelefone) {
          <span class="text-xs text-500">
            <i class="pi pi-phone text-xs"></i>
            {{ formatarTelefoneValor($modalDependente().cliente?.responsavelTelefone) }}
          </span>
        }
      </div>
    </div>

    <div class="pt-2">
      <p-button
        [label]="'BARDO_CLIENTES.CONTINUAR_COM' | translate: { nome: ($modalDependente().cliente?.nome | titlecase) }"
        icon="pi pi-chevron-right"
        iconPos="right"
        severity="primary"
        (click)="confirmarClienteSelecionado($modalDependente().cliente)"
        styleClass="w-full py-3 font-semibold text-base"
      />
    </div>
  </div>
</ng-template>
